module.exports = __webpack_public_path__ + "img/sign_position_legal.9ba9bbf9.png";